import React, {
  Component
} from "react";

class CallbackView extends Component {
  componentWillMount() {
    const {
      auth,
      authCode,
      error
    } = this.props;

    if (error) {
      window.location.href = "/accessForbiddenError";
      return;
    }

    if (authCode) {
      auth.handleAuthentication(authCode);
      return;
    }


  }

  render() {
    const style = {
      position: "absolute",
      display: "flex",
      justifyContent: "center",
      height: "100vh",
      width: "100vw",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: "white"
    };

    return <div style = {
      style
    }
    />;
  }
}

export default CallbackView;


// WEBPACK FOOTER //
// ./src/modules/callback/CallbackView.js